import { render } from "./Tab.vue?vue&type=template&id=75f7158f&ts=true&lang=pug"
import script from "./Tab.vue?vue&type=script&lang=ts&setup=true"
export * from "./Tab.vue?vue&type=script&lang=ts&setup=true"

import "./Tab.vue?vue&type=style&index=0&id=75f7158f&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__